// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"6e1cd95b","96":"dd5fb660","453":"9e9a0b48"}[chunkId] + ".chunk.js";
};